import {api} from "@/api/client";
import {Group} from "@/api/types/Group";



export const buildGroupApi = (client = api) => {
    return {
        async list() {
            const result = await client.get<Group[]>('api/groups');
            return result.data;
        }
    };
};

export const {
    list,
} = buildGroupApi();
